import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { Badge } from '@/global/components/ui/badge'
import { cn } from '@/lib/utils'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import dayjs from 'dayjs'
import Menu from 'global/components/MenuV2'
import { useRef } from 'react'
import { LogCalculos } from 'service/api'

const notificacoes = (row: any) => {
    if (!row)
        return {
            quantidade: 0,
        }
    const logsLength = row.logs?.length ?? 0
    const hasFeriado = Boolean(row.feriado)
    const n = hasFeriado ? logsLength + 1 : logsLength
    let res = n
    if (row.logs?.find((log: any) => log.titulo === 'Admissão'))
        res = n - 1 > 0 ? n - 1 + ' A' : 'A'
    if (row.logs?.find((log: any) => log.titulo === 'Rescisão'))
        res = n - 1 > 0 ? n - 1 + ' R' : 'R'
    return {
        quantidade: n,
        texto: res,
    }
}

export function ExibirDia({ row, value }: GridCellParams) {
    const clickRef = useRef<HTMLDivElement>(null)

    const Display = (
        <div
            title={
                row.feriado ? `Feriado ${row.feriado.nome ?? ''}` : undefined
            }
            className="flex flex-col justify-evenly h-fit"
            ref={clickRef}
        >
            <span className="text-base/5 uppercase">
                {dayjs(value).format('ddd')}
            </span>

            <span className="text-base/5 font-bold">
                {dayjs(value).format('DD/MM')}
            </span>
        </div>
    )

    return (
        <div className="h-full flex items-center overflow-visible relative">
            <Badge
                className={cn(
                    'absolute top-1.5 -right-2 size-5 select-none cursor-pointer',
                    getColor(row, true),
                )}
                onClick={() => {
                    clickRef.current?.click()
                }}
            >
                {notificacoes(row).quantidade > 0
                    ? notificacoes(row).texto
                    : null}
            </Badge>
            {notificacoes(row).quantidade > 0 ? (
                <Menu.Root position="left">
                    <Menu.Trigger pointer>{Display}</Menu.Trigger>
                    <Menu.List
                        elevation={1}
                        sx={{
                            '& .MuiList-root': {
                                padding: 0,
                            },
                        }}
                    >
                        {row.feriado && (
                            <Alert
                                sx={{
                                    minWidth: 400,
                                }}
                                severity="info"
                            >
                                <AlertTitle>Feriado</AlertTitle>
                                {row.feriado.nome}
                            </Alert>
                        )}
                        {row.logs?.map((log: LogCalculos, i: number) => (
                            <Alert severity={getColor({ logs: [log] })} key={i}>
                                <AlertTitle>{(log as any).titulo}</AlertTitle>
                                {log.descricao}
                            </Alert>
                        ))}
                    </Menu.List>
                </Menu.Root>
            ) : (
                Display
            )}
        </div>
    )
}

function getColor<T extends string>(row: any, badge?: boolean): T | undefined {
    let type: string
    if (row.logs?.length) {
        if (row.logs.some((log: LogCalculos) => log.variante === 'error')) {
            type ??= 'error'
        } else if (
            row.logs.some((log: LogCalculos) => log.variante === 'warning')
        ) {
            type ??= 'warning'
        } else if (
            row.logs.some((log: LogCalculos) => log.titulo === 'Rescisão')
        ) {
            type ??= badge ? 'primary' : 'info'
        } else if (
            row.logs.some((log: LogCalculos) => log.variante === 'info')
        ) {
            type ??= 'info'
        } else if (
            row.logs.some((log: LogCalculos) => log.variante === 'success')
        ) {
            type ??= 'success'
        }
    } else if (row.feriado) {
        type ??= 'info'
    }

    type ??= ''
    switch (type) {
        case 'error':
            return badge ? ('bg-error' as T) : ('error' as T)
        case 'warning':
            return badge ? ('bg-warning' as T) : ('warning' as T)
        case 'info':
            return badge ? ('bg-info' as T) : ('info' as T)
        case 'primary':
            return badge ? ('bg-primary' as T) : ('info' as T)
        case 'success':
            return badge ? ('bg-success' as T) : ('success' as T)
        default:
            return undefined
    }
}
